module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_9005.b2418098.png";